import React, {useState, useEffect, useCallback} from 'react';

export default ({recording, setDeleting, deleting, onClickRecord}) => {
    let recClass = "button-option";
    if (recording) {
        recClass += " selected";
    }

    let delClass = "button-option";
    if (deleting) {
        delClass += " selected";
    }

    return (
        <div className="sample-options">
          <div className="buttons">
          <div
            onClick={onClickRecord}
            className={recClass}>
            Rec 
          </div>
          <div
            onMouseDown={() => setDeleting(true)}
            onMouseUp={() => setDeleting(false)}
            className={delClass}>
            Del 
          </div>
          </div>
        </div>
    );
}
